import React from 'react'

function Cart({ color }) {
    return (
        <svg viewBox="0 0 106 106" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.3321 14.1111H103L91.8889 53H27.3151M97.4444 75.2222H30.7778L19.6667 3H3M36.3333 97.4444C36.3333 100.513 33.846 103 30.7778 103C27.7096 103 25.2222 100.513 25.2222 97.4444C25.2222 94.3761 27.7096 91.8889 30.7778 91.8889C33.846 91.8889 36.3333 94.3761 36.3333 97.4444ZM97.4444 97.4444C97.4444 100.513 94.9572 103 91.8889 103C88.8206 103 86.3333 100.513 86.3333 97.4444C86.3333 94.3761 88.8206 91.8889 91.8889 91.8889C94.9572 91.8889 97.4444 94.3761 97.4444 97.4444Z" stroke={color ?? '#ffffff'} strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default Cart